import { useMemo } from 'react'

const roleChecker = () => {
  const roles_cookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('roles'));
  return !!roles_cookie;
}

export function useLoggedIn() {
  const result = useMemo( roleChecker, [] );

  return result;
}